import styled from 'styled-components';
import { timingDefault } from '../../constants';
export const Container = styled.div(({ theme: { dropdown } }) => ({
    cursor: 'pointer',
    fontSize: dropdown.typography.primary.fontSize,
    fontWeight: dropdown.typography.primary.fontWeight,
    letterSpacing: dropdown.typography.primary.letterSpacing,
    position: 'relative',
    textAlign: 'start',
}));
export const Main = styled.div(({ isInvalid, isOpen, theme: { color }, variant }) => ({
    'backgroundColor': isOpen && variant === 'box' ? color.deprecated.stoneLight : 'unset',
    'borderColor': determinMainBorderColor(isInvalid, isOpen, false, variant, color.deprecated),
    'borderRadius': '4px',
    'borderStyle': 'solid',
    'borderWidth': variant === 'line' ? '0 0 1px' : '1px',
    'boxSizing': 'border-box',
    'display': 'flex',
    'outline': 'none',
    '&:focus': {
        borderColor: determinMainBorderColor(isInvalid, isOpen, true, variant, color.deprecated),
    },
}));
function determinMainBorderColor(isInvalid, isOpen, isFocused, variant, color) {
    if (isOpen && variant === 'box')
        return color.gray.medium;
    if (isOpen && variant === 'line')
        return color.black.primary;
    if (isFocused)
        return color.black.primary;
    if (isInvalid)
        return color.red.error;
    return color.gray.medium;
}
export const Selection = styled.div `
  color: ${o => o.hasSelected ? o.theme.color.deprecated.obsidian : o.theme.color.deprecated.obsidianLight};
  flex: 1;
  padding: 17px 20px 17px 14px;
  white-space: nowrap;

  ${Main}:focus & {
    color: ${o => o.isOpen ? o.theme.color.deprecated.obsidianLight : o.theme.color.deprecated.obsidian};
  }
`;
export const IconWrapper = styled.div `
  align-items: center;
  display: flex;
  justify-content: center;
  padding-inline-end: 14px;
  transform: ${o => o.isOpen && 'rotateX(-180deg)'};
  transition: transform ${timingDefault} linear;
`;
export const Options = styled.div(({ theme: { color, dropdown, zIndex }, variant, isScrollable = false }) => ({
    backgroundColor: color.deprecated.white.primary,
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    borderColor: color.deprecated.gray.medium,
    borderStyle: 'solid',
    borderWidth: variant === 'box' ? `0 ${dropdown.borderWidth} ${dropdown.borderWidth}` : 0,
    bottom: 0,
    boxSizing: 'border-box',
    left: 0,
    position: 'absolute',
    transform: 'translateY(100%)',
    width: '100%',
    zIndex: zIndex.foregroundContent,
    maxHeight: isScrollable ? '200px' : 'auto',
    overflowY: isScrollable ? 'scroll' : 'auto',
    overflowX: 'hidden',
}));
export const Option = styled.div(({ isHovered, isSelected, theme: { color } }) => ({
    backgroundColor: isSelected
        ? color.deprecated.black.primary
        : isHovered
            ? color.deprecated.gray.lightest
            : 'unset',
    boxSizing: 'border-box',
    color: isSelected ? color.deprecated.white.primary : '#000',
    fontWeight: isSelected ? 700 : 600,
    padding: '8px 16px',
    width: '100%',
}));
export const PlaceholderOption = styled.div(({ theme: { color } }) => ({
    color: color.deprecated.gray.medium,
    cursor: 'default',
    padding: '8px 16px',
    width: '100%',
}));
export const InvalidMessage = styled.div(({ theme: { color, dropdown } }) => ({
    color: color.deprecated.red.error,
    fontSize: dropdown.typography.invalidMessage.fontSize,
    letterSpacing: dropdown.typography.invalidMessage.letterSpacing,
    paddingTop: '8px',
}));
//# sourceMappingURL=styles.js.map